import $ from "jquery";
import { register } from "@shopify/theme-sections";
import {
	onWishlistLoad,
	addToWishlist,
	removeFromWishList,
	isInWishlist
} from "../core/helpers/swym";
import Slider from "../components/slider/slider";
// eslint-disable-next-line
import { ezPuls } from "../core/helpers/jquery.ez-plus";

const selectors = {
	header: "#shopify-section-header",
	addToCardItem: "[data-add-to-card]",
	productCard: {
		wrapper: "[data-main-product-card-wrapper]",
		card: "[data-product-card]",
		mainImg: "[data-product-cart-img]"
	},
	customizablePage: {
		customizableInputGroup: "[data-customizable-input-group]",
		customizableMonogrammInput: "[data-customizable-input]",
		customizableOptions: {
			section: '[data-section-type="customizable-product"]',
			form: "[data-product-form]"
		}
	},
	settingsBlock: "[data-main-product-settings-block]",
	pdpSlider: {
		sliderContainer: "[data-pdp-slider-container]",
		sliderWrapper: "[data-pdp-slider-wrapper]",
		slide: "[data-product-pdp-slide]",
		arrowNext: "[data-pdp-slider-arrow-next]",
		arrowPrev: "[data-pdp-slider-arrow-prev]",
		pagination: ".slider__pagination"
	},
	pdpThumbsSlider: {
		sliderContainer: "[data-pdp-thumbs-slider-container]",
		sliderWrapper: "[data-pdp-thumbs-slider-wrapper]",
		slide: "[data-product-pdp-thumbs-slide]"
	},
	medallions: {
		wrapper: "[data-medallions-wrapper]",
		accordionButton: "[data-medallion-accordion-button]",
		contentWrapper: "[data-medallion-content-wrapper]",
		content: "[data-medallions-content]",
		medallion: "[data-medallion-item]"
	},
	availabilityBlock: {
		showAvailabilityBtn: "[data-show-availability]",
		wrapper: "[data-product-availability-wrapper]",
		block: "[data-product-availability-block]",
		close: "[data-product-availability-close]"
	},
	variants: "[data-product-variants-wrapper]",
	deliveryTime: "[data-main-product-delivery-terms]",
	variantsContainer: "[data-product-variants-container]",
	variantsContainerNext: "[data-product-variants-container-arrow-next]",
	variantsContainerPrev: "[data-product-variants-container-arrow-prev]",
	variantsContainerScrollbar: "[data-product-variants-container-scrollbar]",
	loadMoreDecors: "[data-load-more-decors]",
	decorsBlock: "[data-decors-block]",
	variantInventoryPolicyAttr: "data-variant-inventory-policy",
	productInfoBlock: "[data-main-product-info-block]",
	addToCardError: "[data-add-to-card-error]",
	addToCardErrorCount: "[data-type-error-max-count]",
	counter: {
		wrapper: "[data-quantity-selector]",
		input: "[data-quantity-input]",
		formInput: "[data-customizable-product-quantity]",
		incrementBtn: "[data-quantity-increment-button]",
		decrementBtn: "[data-quantity-decrement-button]",
		availabilityLabel: "[data-product-availability-label]",
		addToCardBtn: "[data-product-add-to-card-btn]",
		errorMessage: "[data-quantity-error-message]"
	},
	storeAvailableAccordion: {
		storeAvailability: "[data-accordion-store-availability]",
		wrapper: "[data-accordion-store-available-wrapper]"
	},
	accordions: {
		productDimesions: "[data-product-accordion-dimensions]",
		productInformation: "[data-product-accordion-information]",
		productMaintenance: "[data-accordion-maintenance]",
		productCollectionInform: "[data-accordion-collection-information]",
		setProducts: "[data-accordion-set-products]",
		storeAvailabilityContent: "[data-accordion-store-availability-content]"
	},
	wishlistButtons: "[data-add-to-wishlist]",
	wishlistButtonsPrevent: ".product-card__wishlist",
	backInStock: {
		wrapper: "[data-back-in-stock-wrapper]",
		form: "[data-back-in-stock-form]",
		submit: "[data-back-in-stock-submit]",
		email: "[data-back-in-stock-email]",
		publicApiKey: "[data-back-in-stock-api-key]",
		status: "[data-back-in-stock-status]"
	},
	zoom: {
		zoomImageWrapper: "[data-zoom-image-wrapper]"
	}
};

const modifiers = {
	hiddenHeader: "shopify-section-header-hidden",
	hidden: "hidden",
	load: "load",
	wishlist: {
		added: "button--wishlist-added"
	}
};

register("product", {
	pdpPage: {
		isMedallionTemplate: false,
		medallions: {},
		slider: null
	},
	customizablePage: {
		isCustomizablePage: false
	},
	currentProduct: {},
	currentVariant: {},
	variantAvailable: {},
	currentVariantAvailable: null,
	productCardContent: {},
	currentProductHandle: $(selectors.productCard.card).attr("data-handle"),
	customizableProperties: {},
	currentVariantAccordionContent: {},
	currentInventoryPolicy: $(selectors.productInfoBlock).attr(
		selectors.variantInventoryPolicyAttr
	),
	isContinueSelling:
		$(selectors.productInfoBlock).attr(
			selectors.variantInventoryPolicyAttr
		) === "continue"
			? true
			: false,
	customizableSection: $(
		selectors.customizablePage.customizableOptions.section
	),
	customizableForm: $(selectors.customizablePage.customizableOptions.form),
	wishlistButtons: null,
	backInStock: {},

	heightOfDecorContainer: $(selectors.variantsContainer).height(),

	init: async function () {
		await this.getProductJSON();
		await this.actualizeVariant();
		this.updateCartQuantity();
		this.registerEvents();

		this.registerCounterAndAddToCart();
		this.registerStickyEvents();
		this.registerTeaserSetEvents();
		this.registerProductCardEvents();
		this.registerAvailabilityOverlay();

		this.actualizeDecors();
		this.initWishlist();
		this.updateBackInStock();
		this.changeDeliveryTime();
		this.initVariantSlider();
	},
	getProductJSON: async function () {
		const url = `/products/${this.currentProductHandle}?view=object-json`;
		const data = await fetch(url).then((res) => res.json());

		data.available
			.split(",")
			.slice(1)
			.forEach((string) => {
				let splittedString = string.split("variant_available");
				this.variantAvailable[splittedString[1].trim()] =
					splittedString[0].trim();
			});
		// customizable products are not tracked
		if (this.customizableSection.length > 0) {
			// this.customizablePage.isCustomizablePage is not yet set here
			Object.keys(this.variantAvailable).forEach((key) => {
				this.variantAvailable[key] = "99";
			});
		}
		this.currentProduct = data.product;
		this.pdpPage.isMedallionTemplate = this.currentProduct.tags
			.map((tag) => tag.toLowerCase())
			.includes("arc") || this.currentProduct.tags
			.map((tag) => tag.toLowerCase())
			.includes("abc");

		if (this.pdpPage.isMedallionTemplate) {
			// Main Decor articles are only used in listings and cannot be purchased
			for (const variant of data.product.variants) {
				if (variant.options.includes("Main Decor")) {
					this.variantAvailable[variant.id] = 0;
				}
			}
		}
	},
	updateCartQuantity: async function () {
		const changeQuantity = (response) => {
			$("[data-header-icon-cart-count]").addClass("hidden").text("");
			if (+response.item_count > 0) {
				$("[data-header-icon-cart-count]")
					.removeClass("hidden")
					.text(response.item_count);
			}
		};
		$.ajax({
			url: "/cart.js",
			contentType: "application/json",
			dataType: "json",
			success: function (response) {
				changeQuantity(response);
			},
			error: function (error) {
				console.log(error);
			}
		});
	},
	actualizeDecors: function () {
		const toggleDecors = () => {
			$(selectors.variantsContainer).hasClass("collapse")
				? $(selectors.variantsContainer).removeClass("collapse")
				: $(selectors.variantsContainer).addClass("collapse");
		};
		$(selectors.loadMoreDecors).on("click", toggleDecors);
		if ($(selectors.variants).length > 4) {
			$(selectors.loadMoreDecors).removeClass("hide");
			$(selectors.loadMoreDecors)
				? $(selectors.loadMoreDecors).trigger("click")
				: null;
		}
	},
	actualizeVariant: function () {
		if (this.currentProduct.variants.length > 0) {
			this.currentVariant =
				this.currentProduct.variants.filter(
					(variant) => +variant.id === +this.getUrlParam("variant")
				)[0] || this.currentProduct.variants[0];
			this.currentVariantAvailable =
				this.variantAvailable[this.currentVariant.id];
		}
		if (this.pdpPage.isMedallionTemplate) {
			const medallionsLength = $(selectors.medallions.medallion).length;

			$(selectors.medallions.accordionButton).removeClass("disabled");
			if (medallionsLength < 2) {
				$(selectors.medallions.accordionButton).addClass("disabled");
			}

			this.currentVariant =
				this.currentProduct.variants.filter(
					(variant) => +variant.id === +this.getUrlParam("variant")
				)[0] || this.currentProduct.variants[0];
			const activeMedallion = $(selectors.medallions.medallion).filter(
				(_, element) => $(element).hasClass("active")
			);


			if (+$(activeMedallion).attr("data-medallion-index") > 0) {
				$(selectors.medallions.accordionButton).text(
					$(activeMedallion).text().trim()
				);
			}
		}
		this.initSlider(0);
		this.checkAvailability();
	},
	checkAvailability: function () {
		if (!$(".pickup-availability-list__item").length) {
			$(selectors.settingsBlock).addClass("non-availability");
		} else {
			$(selectors.settingsBlock).removeClass("non-availability");
		}
	},
	registerEvents: function () {
		// Decoration variants
		$(selectors.variantsContainer).on("click", (event) => {
			if (event.target.tagName !== "IMG") {
				return;
			}
			this.getCurrentVariant(event);
		});

		$(selectors.medallions.medallion).on("click", ({ currentTarget }) => {
			$(selectors.medallions.accordionButton).trigger("click");
			$(selectors.medallions.accordionButton).text(
				$(currentTarget).text().trim()
			);
			this.changeMedallion(currentTarget);
		});

		//Customizable section
		$(selectors.customizablePage.customizableOptions.form).on(
			"change",
			() => {
				let $customizableOptions = $(
					`${selectors.customizablePage.customizableOptions.form} option[selected="true"]`
				);
				this.currentVariant = {
					id: $customizableOptions.val(),
					price: $customizableOptions.attr("data-variant-price")
				};
				this.changeProductInformation();
			}
		);
	},
	initVariantSlider: function () {
		let sliderContainer = $(selectors.variantsContainer).get(0);
		let sliderOptions = {
			initialSlide: $(selectors.variantsContainer)
				.find(".active")
				.index(),
			navigation: {
				nextEl: $(selectors.variantsContainerNext).get(0),
				prevEl: $(selectors.variantsContainerPrev).get(0)
			},
			loop: true,
			slidesPerView: "auto",
			speed: 0,
			on: {
				afterInit: () => {
					$(sliderContainer).addClass("initialized");
				}
			}
		};
		if ($(selectors.variantsContainer).find(".swiper-slide").length <= 5) {
			$(selectors.variantsContainer).addClass("js-slider-no-buttons");
			return;
		}
		new Slider(sliderContainer, sliderOptions);
	},
	registerCounterAndAddToCart: function () {
		// Counter
		$(selectors.counter.input).on("change", (event) => {
			this.changeInput.call(this, event);
			$(".main-product-sticky")
				.find(selectors.counter.input)
				.val($(event.target).val());
		});
		$(selectors.counter.input).on("input", (event) => {
			if ($(selectors.productInfoBlock).hasClass("disabled")) {
				event.target.value = "0";
			}
		});
		$(selectors.counter.incrementBtn).off("click"); // prevents double binding, registerCounter... function called twice sometimes
		$(selectors.counter.incrementBtn).on(
			"click",
			this.increment.bind(this)
		);
		$(selectors.counter.decrementBtn).off("click"); // prevents double binding, registerCounter... function called twice sometimes
		$(selectors.counter.decrementBtn).on(
			"click",
			this.decrement.bind(this)
		);
		// Add to card button
		$(selectors.counter.addToCardBtn).on(
			"click",
			this.addToCard.bind(this)
		);
		document.addEventListener("Added3DProductInCart", () => {
			this.redirectToCart = true;
			this.addToCard();
		});
		// Add to card events
		$(selectors.addToCardItem).on("click", ({ currentTarget }) => {
			const variantId = +$(currentTarget).attr("data-add-to-card");
			this.addToCard.call(this, null, variantId, 1);
		});
	},
	registerStickyEvents: function () {
		const box = document.querySelector(selectors.counter.addToCardBtn);
		const rect = box.getBoundingClientRect();
		const MARGIN = 100;
		const isInViewport =
			rect.top >= MARGIN &&
			rect.left >= 0 &&
			rect.bottom <=
				(window.innerHeight || document.documentElement.clientHeight) &&
			rect.right <=
				(window.innerWidth || document.documentElement.clientWidth);
		if (isInViewport) {
			// is visible
			$(".main-product-sticky").css("bottom", "translateY(100%)");
			$('#shopify-section-toolbar .toolbar').css('bottom', "");
		} else {
			$(".main-product-sticky").css("bottom", "translateY(0%)");
			$('#shopify-section-toolbar .toolbar').css('bottom', "120px");
		}
		$(
			".main-product-sticky-mobile-add-button, .main-product-sticky-desktop-add-button"
		).on("click", function (e) {
			e.preventDefault();
			$(selectors.counter.addToCardBtn).trigger("click");
		});
		$(".main-product-sticky")
			.find("[data-quantity-decrement-sticky-button]")
			.on("click", function (e) {
				e.preventDefault();
				$(selectors.counter.decrementBtn).first().trigger("click");
				return false;
			});
		$(".main-product-sticky")
			.find("[data-quantity-increment-sticky-button]")
			.on("click", function (e) {
				e.preventDefault();
				$(selectors.counter.incrementBtn).first().trigger("click");
				return false;
			});
		$(".main-product-sticky")
			.find(selectors.counter.input)
			.on("change", function (e) {
				e.preventDefault();
				$(selectors.counter.input).val($(e.target).val());
				$(selectors.counter.input).first().trigger("change");
			});

		let observer = new IntersectionObserver(function (entry) {
			if (entry[0].isIntersecting) {
				// is visible
				$(".main-product-sticky").css("transform", "translateY(100%)");
				$('#shopify-section-toolbar .toolbar').css('bottom', "");
			} else {
				$(".main-product-sticky").css("transform", "translateY(0%)");
				$('#shopify-section-toolbar .toolbar').css('bottom', "120px");
			}
		});
		observer.observe(document.querySelector(".main-product__hero-block"), {
			rootMargin: MARGIN
		});
	},
	registerSliderOverlayEvents: function () {
		const slider = this.pdpPage.slider;
		$("[data-pdp-slider-wrapper], [data-medallions-slider-wrapper]").on("click", function (e) {
			e.preventDefault();
			$("[data-product-card]").addClass("pdp-slider-overlay");
			slider.instance.update();
			slider.thumbs?.instance.update();
			console.log("!!!1");
			setTimeout(()=>{ slider.instance.update(); }, 1000);
		});
		$("[data-overlay-close]").on("click", function (e) {
			e.preventDefault();
			$("[data-product-card]").removeClass("pdp-slider-overlay");
			slider.instance.update();
			console.log("???1");
			setTimeout(()=>{ slider.instance.update(); }, 1000);
			return false;
		});
	},
	registerTeaserSetEvents: function () {
		if (
			$(".product__teaser-set").length &&
			$(".product__teaser-set .product__teaser-set-teaser").length < 3
		) {
			$(".product__teaser-set-teasers").removeClass(
				"js-product__teaser-set-unopened"
			);
			$(".product__teaser-set-show-all").css("display", "none");
		}
		$(".js-product__teaser-set-unopened")
			.next()
			.on("click", function (e) {
				e.preventDefault();
				$(e.target).css("display", "none");
				$(e.target)
					.prev()
					.removeClass("js-product__teaser-set-unopened");
			});
	},
	registerProductCardEvents: function () {
		$(".product-card__title-text-more").on("click", function (e) {
			e.preventDefault();
			if ($(".product__detail-long-text-wrapper").length) {
				$("html, body").animate(
					{
						scrollTop:
							$(".product__detail-long-text-wrapper").offset()
								.top - 175
					},
					"slow"
				);
			} else {
				$("html, body").animate(
					{
						scrollTop: $(".product__detail-grid").offset().top
					},
					"slow"
				);
			}
		});
	},
	registerAvailabilityOverlay: function () {
		$("[data-show-availability]").on("click", function (e) {
			e.preventDefault();
			$("[data-product-availability-wrapper]").removeClass("hide");
		});
		$("[data-product-availability-close]").on("click", function (e) {
			e.preventDefault();
			$("[data-product-availability-wrapper]").addClass("hide");
		});
		$("[data-product-availability-wrapper] + div").on(
			"click",
			function (e) {
				e.preventDefault();
				$("[data-product-availability-wrapper]").addClass("hide");
			}
		);
	},
	sortAvailablityStores: function () {
		const availabilityStores = $(".pickup-availability-list__item");
		const newArray = [];
		if (availabilityStores.length) {
			availabilityStores.each((_, element) => {
				if ($(element).attr("data-order")) {
					newArray[$(element).attr("data-order")] = element;
					$(element).remove();
				} else {
					newArray.unshift(element);
				}
			});
		}
		newArray.forEach((listItem) => {
			$("[data-store-availability-drawer-content]").append(listItem);
		});
	},
	changeAccordionContent: async function () {
		return;
	},
	actualizeAccordion: function (documentHtml, selector) {
		if (selector === "setProducts") {
			if (!$(documentHtml).find(".set-product--wrapper").length) {
				$(selectors.accordions.setProducts).parent().hide();
				return;
			} else {
				$(selectors.accordions.setProducts).parent().show();
			}
		}

		let accordion = $(selectors.accordions[selector]);

		accordion
			? $(selectors.accordions[selector]).html(accordion.innerHTML)
			: null;
	},
	// Initial getters
	getUrlParam: function (name) {
		let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
		let r = window.location.search.substr(1).match(reg);
		if (r != null) return unescape(r[2]);
		return "none";
	},
	getCurrentVariant: async function (event) {
		const productVariants = $(selectors.variants);
		[...productVariants].forEach((variant) => {
			variant.classList.contains("active")
				? variant.classList.remove("active")
				: null;
		});
		event.target.parentNode.classList.add("active");
		this.currentVariant = this.currentProduct.variants.find(
			(variant) => variant.id === +event.target.parentNode.dataset.id
		);
		if (this.pdpPage.isMedallionTemplate) {
			if (
				$(selectors.medallions.accordionButton)
					.parent()
					.hasClass("active")
			) {
				$(selectors.medallions.accordionButton).trigger("click");
			}
			$(selectors.medallions.accordionButton).text(
				$(selectors.medallions.accordionButton).attr(
					"data-default-title"
				)
			);
			await this.changeMedallionAccrodion();
			await this.getProductCardSection();
			this.changeURL();
			await this.changeAccordionContent();
			this.changeProductAvailability(event);
			this.changeAccordionContent();
			this.changeDeliveryTime();
		} else {
			this.changeProductInformation();
		}
		this.updateBackInStock();
	},
	getProductCardSection: async function () {
		const url_product = `/products/${this.currentProductHandle}/?variant=${this.currentVariant.id}`;
		await fetch(url_product)
			.then((res) => res.text())
			.then((text) => {
				const dom = new DOMParser().parseFromString(text, "text/html");
				let productCardNewDom = dom.querySelector(selectors.productCard.card);
				$(selectors.productCard.card).replaceWith(productCardNewDom);

				let elementWrapper = dom.querySelector(
					".product-card__meta-wrapper"
				);
				$(".product-card__meta-wrapper").replaceWith(elementWrapper);

				$(".main-product-sticky").replaceWith(
					dom.querySelector(".main-product-sticky")
				);
				this.registerStickyEvents();

				$(".product-card__title-text-wrapper").replaceWith(
					dom.querySelector(".product-card__title-text-wrapper")
				);
				this.registerProductCardEvents();
				$(
					".main-product__settings-block__product-availability  "
				).replaceWith(
					dom.querySelector(
						".main-product__settings-block__product-availability  "
					)
				);
				$(".pdp-product-variant--combeenation-url").remove();
				$(
					dom.querySelector(".pdp-product-variant--combeenation-url")
				).insertAfter($(".main-product__settings-block__decorations"));

				this.registerAvailabilityOverlay();
				$(".main-product__settings-block__product-info").replaceWith(
					dom.querySelector(
						".main-product__settings-block__product-info"
					)
				);

				$(dom)
					.find("[data-main-product-info-block]")
					.attr("data-variant-inventory-policy") === "continue"
					? (this.isContinueSelling = true)
					: (this.isContinueSelling = false);

				if (this.pdpPage.isMedallionTemplate) {
					const activeMedallion = $(selectors.medallions.medallion).filter(
						(_, element) => $(element).hasClass("active")
					);

					if (+$(activeMedallion).attr("data-medallion-index") > 0) {
						$('.main-product__settings-block__product-availability').css('display', 'block');
						$('.back-in-stock').css('display', '');
					}else{
						$('.main-product__settings-block__product-availability').css('display', 'none');
						$('.back-in-stock').css('display', 'none');
					}
				}

				this.registerCounterAndAddToCart();
				this.initSlider(0);

				$(".product__detail").replaceWith(
					dom.querySelector(".product__detail")
				);
				$(".product__three-img").replaceWith(
					dom.querySelector(".product__three-img")
				);
				$(".product__images-slider").replaceWith(
					dom.querySelector(".product__images-slider")
				);
				Shopify.theme.sections.instances.find(
					x => x.container.classList.contains('images-slider')
				).onLoad();
				$(".product__teaser-set").replaceWith(
					dom.querySelector(".product__teaser-set")
				);
				this.registerTeaserSetEvents();
			});
	},
	// Counter
	changeInput: function (event) {
		let value = event.target.value;
		if (!Number.isNaN(+value)) {
			if (value.length >= 3) {
				!$(selectors.counter.wrapper).hasClass("large")
					? $(selectors.counter.wrapper).addClass("large")
					: null;
			} else if (value.length < 3) {
				$(selectors.counter.wrapper).hasClass("large")
					? $(selectors.counter.wrapper).removeClass("large")
					: null;
			}
			if (value.length == 0) {
				event.target.value = 1;
			} else if (
				$(selectors.productInfoBlock).attr(
					selectors.variantInventoryPolicyAttr
				) === "continue"
			) {
				if (+$(selectors.counter.input).val() > 9999) {
					$(selectors.counter.input).val(9999);
					$(selectors.counter.errorMessage).fadeIn(
						"slow",
						function () {
							setTimeout(() => {
								$(selectors.counter.errorMessage).fadeOut(
									"slow"
								);
								$(selectors.counter.input).trigger("focus");
							}, 3000);
						}
					);
				}
			} else if (+value > +this.currentVariantAvailable) {
				event.target.value = this.currentVariantAvailable;
				$(selectors.counter.errorMessage).fadeIn("slow", function () {
					setTimeout(() => {
						$(selectors.counter.errorMessage).fadeOut("slow");
						$(selectors.counter.input).trigger("focus");
					}, 3000);
				});
			}
		} else {
			event.target.value = event.target.value.slice(0, -1);
		}
		if (+value < 0) {
			$(selectors.counter.input).val(0);
			$(selectors.counter.input).trigger("focus");
		}
	},
	increment: function () {
		const counterInput = $(selectors.counter.input);
		let currentVal = +counterInput.val();
		// Continue selling
		if (
			$(selectors.productInfoBlock).attr(
				selectors.variantInventoryPolicyAttr
			) === "continue"
		) {
			if (currentVal + 1 > 9999) {
				$(selectors.counter.errorMessage).fadeIn("slow", function () {
					setTimeout(() => {
						$(selectors.counter.errorMessage).fadeOut("slow");
						$(selectors.counter.input).trigger("focus");
					}, 3000);
				});
				return;
			}
			counterInput.val(currentVal + 1);
			if ($(selectors.counter.input).val().length >= 3) {
				!$(selectors.counter.wrapper).hasClass("large")
					? $(selectors.counter.wrapper).addClass("large")
					: null;
			}
			return;
		}
		if (currentVal < +this.currentVariantAvailable) {
			counterInput.val(currentVal + 1);
		} else {
			$(selectors.counter.errorMessage).fadeIn("slow", function () {
				setTimeout(() => {
					$(selectors.counter.errorMessage).fadeOut("slow");
					$(selectors.counter.input).trigger("focus");
				}, 3000);
			});
		}
	},
	decrement: function () {
		const counterInput = $(selectors.counter.input);
		let currentVal = +counterInput.val();
		currentVal > 1 ? counterInput.val(currentVal - 1) : null;
		if ($(selectors.counter.input).val().length < 3) {
			$(selectors.counter.wrapper).hasClass("large")
				? $(selectors.counter.wrapper).removeClass("large")
				: null;
		}
	},
	setCustomizableProperties: function () {
		if (this.customizableSection.length > 0) {
			this.customizablePage.isCustomizablePage = true;
			const customizableFormData = this.customizableForm.serializeArray();
			let localPropsObject = {};
			$(customizableFormData).each(function (index, item) {
				if (item.name.includes("properties")) {
					let customPropsName = item.name
						.replace("properties[", "")
						.replace("]", "");
					let customPropsObject = { [customPropsName]: item.value };
					localPropsObject = {
						...localPropsObject,
						...customPropsObject
					};
				}
			});
			this.customizableProperties = localPropsObject;
		}
	},
	initialErrorMessageCustomizableInput() {
		$(selectors.customizablePage.customizableInputGroup).addClass("error");
		$(selectors.customizablePage.customizableMonogrammInput).focus();
		setTimeout(() => {
			$(selectors.customizablePage.customizableInputGroup).removeClass(
				"error"
			);
		}, 3000);
	},
	validationCustomizableInput() {
		// eslint-disable-next-line
		const reg = new RegExp("[а-яА-ЯёЁa-zA-Z0-9$@:.;%&*?#!№()]", "g");
		const monogramm =
			this.customizableProperties?.Monogramm?.trim() || null;
		if (monogramm) {
			const match_length = monogramm.match(reg).length;
			if (match_length === monogramm.length) {
				return true;
			} else {
				return false;
			}
		} else {
			return false;
		}
	},
	addToCard: async function (
		event,
		id = null,
		quantity = null,
		properties = null
	) {
		this.setCustomizableProperties();
		if ($(selectors.customizablePage.customizableInputGroup).length) {
			if (!this.validationCustomizableInput()) {
				this.initialErrorMessageCustomizableInput();
				return;
			}
		}
		let currentQuantity = null;
		let isContinueSelling =
			$(selectors.productInfoBlock).attr(
				selectors.variantInventoryPolicyAttr
			) === "continue";
		/* eslint-disable */
		/* Check for "combeenation" in copyLink added to exclude Combeenation products from the stock check, since these
		 1) don't have this.isContinueSelling and 2) no stock tracked for these */
		if (
			+$(selectors.counter.input).val() > +this.currentVariantAvailable &&
			!isContinueSelling &&
			!(
				this.customizableProperties.copyLink &&
				this.customizableProperties.copyLink.includes("combeenation")
			)
		) {
			$(selectors.counter.input).val(this.currentVariantAvailable);
			$(selectors.counter.errorMessage).fadeIn("slow", function () {
				setTimeout(() => {
					$(selectors.counter.errorMessage).fadeOut("slow");
					$(selectors.counter.input).trigger("focus");
				}, 3000);
			});
			return;
		} else if (+$(selectors.counter.input).val() > 9999) {
			$(selectors.counter.input).val(9999);
			$(selectors.counter.errorMessage).fadeIn("slow", function () {
				setTimeout(() => {
					$(selectors.counter.errorMessage).fadeOut("slow");
					$(selectors.counter.input).trigger("focus");
				}, 3000);
			});
			return;
		} else if (+$(selectors.counter.input).val() <= 0) {
			$(selectors.counter.input).val(0);
			return;
		}

		this.currentInventoryPolicy === "continue"
			? (currentQuantity = $(selectors.counter.formInput).val())
			: (currentQuantity = $(selectors.counter.input).val());
		let formData = {
			items: [
				{
					id: id || this.currentVariant.id,
					quantity: quantity || $(selectors.counter.input).val(),
					properties: properties || this.customizableProperties,
				},
			],
		};
		const highThis = this;
		$(selectors.counter.addToCardBtn).addClass(modifiers.load);
		$(selectors.header).hasClass(modifiers.hiddenHeader)
			? $(selectors.header).removeClass(modifiers.hiddenHeader)
			: null;

		let redirectToCart = this.redirectToCart ? true : false;
		$.ajax({
			url: "/cart/add.js",
			method: "post",
			dataType: "json",
			data: formData,
			success: function (response) {
				const openMiniCartEvent = new Event("openMiniCart");
				document.dispatchEvent(openMiniCartEvent);
				highThis.updateCartQuantity();
				$(selectors.counter.addToCardBtn).removeClass(modifiers.load);
				if (
					highThis.customizableProperties &&
					Object.keys(highThis.customizableProperties).length
				) {
					$(
						selectors.customizablePage.customizableMonogrammInput
					).val("");
				}

				if (redirectToCart) location.href = "/cart";
			},
			error: async function (error) {
				if (error.status === 422) {
					$(selectors.addToCardErrorCount).html(
						highThis.currentVariantAvailable
					);
					$(selectors.counter.addToCardBtn).removeClass(
						modifiers.load
					);
					$(selectors.addToCardError).fadeIn("slow", function () {
						setTimeout(() => {
							$(selectors.addToCardError).fadeOut("slow");
						}, 3000);
					});
				}

				if (redirectToCart) location.href = "/cart";
			},
		});
	},
	// Changers
	changeProductInformation: async function () {
		this.changeURL();
		await this.getProductCardSection();
		await this.changeAccordionContent();
		this.changeProductAvailability();
		this.updateBackInStock();
		this.changeDeliveryTime();
		if (this.currentInventoryPolicy == "deny") {
			this.changeProductAvailability();
		}
		setTimeout(() => this.initWishlist(), 500);
	},
	updateBackInStock: function () {
		console.log('123123!!!!');
		this.backInStock.wrapper = document.querySelector(
			selectors.backInStock.wrapper
		);
		this.backInStock.form = document.querySelector(
			selectors.backInStock.form
		);
		this.backInStock.submit = document.querySelector(
			selectors.backInStock.submit
		);
		this.backInStock.status = document.querySelector(
			selectors.backInStock.status
		);
		this.backInStock.email = document.querySelector(
			selectors.backInStock.email
		);
		this.backInStock.publicApiKey = document.querySelector(
			selectors.backInStock.publicApiKey
		);

		if (this.backInStock.wrapper === null) {
			return null;
		}
		let isContinueSelling =
			$(selectors.productInfoBlock).attr(
				selectors.variantInventoryPolicyAttr
			) === "continue";

		console.log(this.currentVariantAvailable, isContinueSelling, +this.currentVariantAvailable < 1, !isContinueSelling, "HEEEELLOOOO")

		if (+this.currentVariantAvailable < 1 && !isContinueSelling) {
			this.backInStock.wrapper.classList.remove("hidden");
			this.backInStock.submit.addEventListener(
				"click",
				function (e) {
					e.preventDefault();

					let email = this.backInStock.email.value;
					let self = this;

					if (!this.validateEmail(email)) {
						this.backInStock.status
							.querySelector(".email.error-message")
							.classList.remove("hidden");
						setTimeout(
							function () {
								this.backInStock.status
									.querySelector(".email.error-message")
									.classList.add("hidden");
							}.bind(this),
							3000
						);

						return;
					}

					let klaviyoData = {
						a: window.klaviyoPublicKey.key,
						q: "",
						email: email,
						variant: self.currentVariant.id,
						product: self.currentProduct.id,
						platform: "shopify",
						subscribe_for_newsletter: false,
					};

					$.ajax({
						method: "POST",
						url: "https://a.klaviyo.com/onsite/components/back-in-stock/subscribe",
						data: klaviyoData,
					})
						.done(function (response) {
							if (response.success) {
								self.backInStock.status
									.querySelector(".success-message")
									.classList.remove("hidden");
								setTimeout(
									function () {
										self.backInStock.status
											.querySelector(".success-message")
											.classList.add("hidden");
									}.bind(self),
									3000
								);
							} else {
								self.backInStock.status
									.querySelector(".error-message")
									.classList.remove("hidden");
								setTimeout(
									function () {
										self.backInStock.status
											.querySelector(".error-message")
											.classList.add("hidden");
									}.bind(self),
									3000
								);
							}
						})
						.fail(function (err) {
							self.backInStock.status
								.querySelector(".error-message")
								.classList.remove("hidden");
							setTimeout(
								function () {
									self.backInStock.status
										.querySelector(".error-message")
										.classList.add("hidden");
								}.bind(self),
								3000
							);
						});
				}.bind(this)
			);
		} else {
			this.backInStock.wrapper.classList.add("hidden");
		}
	},
	validateEmail: function (value) {
		const EMAIL_REGEXP =
			/^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/iu;

		return EMAIL_REGEXP.test(value);
	},
	initSlider: function (medallionIndex = 0) {
		const thumbsSliderContainer = $(selectors.productCard.wrapper)
			.find(selectors.pdpThumbsSlider.sliderContainer)
			.get(0);
		const thumbsSlides = $(selectors.pdpThumbsSlider.sliderWrapper).find(
			".swiper-slide"
		);
		const thumbsSliderOptions = {
			navigation: false,
			pagination: false,
			slidesPerView: thumbsSlides.length,
			direction: "vertical",
			allowSlideNext: false,
			allowSlidePrev: false,
			spaceBetween: 15,
			on: {
				slideChange: () => {},
			},
		};
		const sliderContainer = $(selectors.productCard.wrapper)
			.find(selectors.pdpSlider.sliderContainer)
			.get(0);
		const sliderOptions = {
			initialSlide: medallionIndex,
			navigation: {
				nextEl: selectors.pdpSlider.arrowNext,
				prevEl: selectors.pdpSlider.arrowPrev,
			},
			pagination: {
				el: selectors.pdpSlider.pagination,
				type: "bullets",
			},
			isArrowOutside: true,
			on: {
				afterInit: () => {
					$(sliderContainer).addClass("initialized");
				},
				slideChange: () => {},
			},
		};

		this.pdpPage.slider = new Slider(sliderContainer, sliderOptions);
		window.tSlider = this.pdpPage.slider;
		this.registerSliderOverlayEvents();
		if (thumbsSliderContainer) {
			const thumbsSlider = new Slider(
				thumbsSliderContainer,
				thumbsSliderOptions
			);

			let currentActiveSlide = null;
			let previousActiveSlide = null;

			this.pdpPage.slider.instance.on(
				"beforeTransitionStart",
				(swiper) => {
					previousActiveSlide = thumbsSlides.get(
						swiper.previousIndex
					);
					currentActiveSlide = thumbsSlides.get(swiper.activeIndex);

					if (previousActiveSlide && currentActiveSlide) {
						previousActiveSlide.classList.remove(
							"swiper-slide-active"
						);
						currentActiveSlide.classList.add("swiper-slide-active");
					}
				}
			);

			thumbsSlider.instance.on("click", (swiper) => {
				this.pdpPage.slider.instance.slideTo(swiper.clickedIndex);
			});

			thumbsSlider.instance.on("update", () => {
				thumbsSlides.get(0)?.classList.remove("swiper-slide-active");
				currentActiveSlide?.classList.add("swiper-slide-active");
			});

			this.pdpPage.slider.thumbs = thumbsSlider;
		}
	},

	changeMedallion: function (button) {
		$(selectors.medallions.medallion).each((_, item) => {
			$(item).hasClass("active") ? $(item).removeClass("active") : null;
		});
		if ($(button).hasClass("active")) {
			$(button).removeClass("active");
		} else {
			$(button).addClass("active");
			this.currentVariant = this.currentProduct.variants.find(
				(variant) => +variant.id === +$(button).attr("data-id")
			);
			this.changeMedallionVariantSlider();
		}
	},
	changeMedallionVariantSlider: async function () {
		this.getProductCardSection();
		this.changeURL();
		await this.changeAccordionContent();
		this.changeProductAvailability();
		this.changeDeliveryTime();
		if (this.pdpPage.medallionsSlider) {
			this.pdpPage.medallionsSlider = null;
		}
		this.updateBackInStock();
		setTimeout(() => this.initSlider(), 200);
	},
	changeMedallionAccrodion: async function () {
		const url = `/products/${this.currentProductHandle}/?section_id=main-product-settings&variant=${this.currentVariant.id}`;
		await fetch(url)
			.then((res) => res.text())
			.then((text) => {
				const medallions = new DOMParser()
					.parseFromString(text, "text/html")
					.querySelector(".product-medallions__content");
				const medallionsLength = $(medallions).find(
					".product-medallions__item"
				).length;

				$(selectors.medallions.accordionButton).removeClass("disabled");
				if (medallionsLength < 2) {
					$(selectors.medallions.accordionButton).addClass(
						"disabled"
					);
				}

				$(selectors.medallions.content).html(medallions.innerHTML);
				$(selectors.medallions.medallion).on(
					"click",
					({ currentTarget }) => {
						$(selectors.medallions.accordionButton).trigger(
							"click"
						);
						$(selectors.medallions.accordionButton).text(
							$(currentTarget).text().trim()
						);
						this.changeMedallion(currentTarget);
					}
				);
			});
	},
	changeDeliveryTime: function () {
		const deliveryTimeTag = $(selectors.deliveryTime);
		const deliveryText = deliveryTimeTag.attr(
			`${this.currentVariant.id}-delivery-data`
		)
			? deliveryTimeTag.attr(`${this.currentVariant.id}-delivery-data`)
			: deliveryTimeTag.attr(`delivery-data`);
		deliveryTimeTag.text(deliveryText);
	},
	changeURL: function () {
		let locationSearch = window.location.search
			.split("?")
			.filter((part) => !part.includes("variant"))
			.filter(Boolean);
		if (locationSearch.length) {
			let locationString = locationSearch[0]
				.split("&")
				.filter((part) => !part.includes("variant"))
				.join("&");
			window.history.pushState(
				"variant",
				document.title,
				`${window.location.pathname}?${locationString}&variant=${this.currentVariant.id}`
			);
		} else {
			window.history.pushState(
				"variant",
				document.title,
				`?variant=${this.currentVariant.id}`
			);
		}
	},
	changeProductImg: async function () {
		await this.getProductCardSection();
		$(selectors.productCard.wrapper).replaceWith(
			this.productCardContent[this.currentVariant.id]
		);
	},
	changeProductAvailability: function (event) {
		console.log(this.variantAvailable, this.currentVariant.id);
		this.currentVariantAvailable =
			this.variantAvailable[this.currentVariant.id];
		const counterInput = $(selectors.counter.input);
		const availabilityLabel = $(selectors.counter.availabilityLabel);
		const infoBlock = $(selectors.productInfoBlock);
		const availabilityBlock = $(selectors.availabilityBlock.wrapper);
		if (
			this.pdpPage.isMedallionTemplate &&
			event &&
			$(event.currentTarget).hasClass("product-variant--wrapper")
		) {
			infoBlock.addClass("disabled");
			counterInput.val(0);
			$(".quantity-selector").addClass("disabled");
			availabilityLabel
				.text(window.productAvailabilityStatus.out_of_stock)
				.css("color", "#B9251E");
			return;
		}
		// Continue selling
		let isContinueSelling =
			$(selectors.productInfoBlock).attr(
				selectors.variantInventoryPolicyAttr
			) === "continue";
		if (isContinueSelling) {
			infoBlock.removeClass("disabled");
			$(".quantity-selector").removeClass("disabled");
			counterInput.val(1);
			this.currentVariantAvailable =
				this.variantAvailable[this.currentVariant.id];
			availabilityLabel
				.text(window.productAvailabilityStatus.in_stock)
				.css("color", "#198035");
			return;
		}
		if (!+this.currentVariantAvailable) {
			infoBlock.addClass("disabled");
			counterInput.val(0);
			availabilityLabel
				.text(window.productAvailabilityStatus.out_of_stock)
				.css("color", "#B9251E");
		} else if (this.currentVariantAvailable <= 3) {
			infoBlock.removeClass("disabled");
			$(".quantity-selector").removeClass("disabled");
			counterInput.val(1);
			this.currentVariantAvailable =
				this.variantAvailable[this.currentVariant.id];
			availabilityLabel
				.text(window.productAvailabilityStatus.runs_out)
				.css("color", "#FB7D21");
		} else if (this.currentVariantAvailable > 3) {
			infoBlock.removeClass("disabled");
			$(".quantity-selector").removeClass("disabled");
			counterInput.val(1);
			this.currentVariantAvailable =
				this.variantAvailable[this.currentVariant.id];
			availabilityLabel
				.text(window.productAvailabilityStatus.in_stock)
				.css("color", "#198035");
		}
	},
	initWishlist: function () {
		this.wishlistButtons = this.container.querySelectorAll(
			selectors.wishlistButtons
		);
		$(document).on("click", selectors.wishlistButtonsPrevent, (e) => {
			e.preventDefault();
			if (window.screen.width >= 1200) {
				$(selectors.header).hasClass(modifiers.hiddenHeader)
					? $(selectors.header).removeClass(modifiers.hiddenHeader)
					: null;
				const openWishlistEvent = new Event("openWishlistEvent");
				document.dispatchEvent(openWishlistEvent);
			}
		});
		if (!this.wishlistButtons.length) {
			return null;
		}
		for (const button of this.wishlistButtons) {
			this.updateWishlistButtons(this.currentVariant);

			button.addEventListener("click", (e) => {
				e.preventDefault();
				onWishlistLoad(this.saveForLater.bind(this));
			});
		}
	},
	updateWishlistButtons: function (variant) {
		if (!variant) {
			variant = this.currentVariant;
		}
		onWishlistLoad(async () => {
			const isItemInWishlist = await isInWishlist(
				this.currentProduct,
				variant
			);

			let wishlistButton = null;
			if (this.currentProduct.has_only_default_variant) {
				wishlistButton = document.querySelector(
					`[data-wishlist-prod-id="${this.currentProduct.id}"]`
				);
			} else {
				wishlistButton = document.querySelector(
					`[data-wishlist="${variant.id}"]`
				);
			}
			isItemInWishlist
				? wishlistButton.classList.add(modifiers.wishlist.added)
				: wishlistButton.classList.remove(modifiers.wishlist.added);
			wishlistButton.classList.remove(modifiers.hidden);
		});
	},
	saveForLater: async function () {
		let wishlistButton = null;

		if (this.currentProduct.has_only_default_variant) {
			wishlistButton = document.querySelector(
				`[data-wishlist="${this.currentProduct.id}"]`
			);
		} else {
			wishlistButton = document.querySelector(
				`[data-wishlist="${this.currentVariant.id}"]`
			);
		}

		const addItemToWishlist = async () => {
			await addToWishlist(this.currentProduct, this.currentVariant);

			wishlistButton.classList.add(modifiers.wishlist.added);
		};

		const removeItemFromWishlist = async () => {
			await removeFromWishList(this.currentProduct, this.currentVariant);

			wishlistButton.classList.remove(modifiers.wishlist.added);
		};

		const isItemInWishlist = await isInWishlist(
			this.currentProduct,
			this.currentVariant
		);

		if (isItemInWishlist) {
			await removeItemFromWishlist();
		} else {
			await addItemToWishlist();

			const openWishlistEvent = new Event("openWishlistEvent");
			document.dispatchEvent(openWishlistEvent);
		}
	},
	changeWishlistButton: function () {
		document.querySelector(selectors.wishlistButtons).dataset.wishlist =
			this.currentVariant.id;
	},

	// Load
	onLoad: async function () {
		await this.init();
	},
});
